import React from "react"
import NavLink from "../NavLink"
import CurrencyContext from "../../context/CurrencyContext"
import Pricing from "../ui/Pricing"
import { useStaticQuery, graphql } from "gatsby"
const WordpressHostingBlock = () => {
  const allData = useStaticQuery(graphql`
    query {
      allProductsJson(filter: { pid: { eq: 41 } }) {
        edges {
          node {
            pid
            name
            description
            pricing {
              INR {
                prefix
                suffix
                monthly
                annually
              }
              MYR {
                prefix
                suffix
                monthly
                annually
              }
              SGD {
                prefix
                suffix
                monthly
                annually
              }
              USD {
                prefix
                suffix
                monthly
                annually
              }
              GBP {
                prefix
                suffix
                monthly
                annually
              }
            }
          }
        }
      }
    }
  `)
  const data = allData.allProductsJson.edges
  return (
    <div className="col-12 col-md-4">
      <div className="card">
        <div className="card-body">
          <h3 className="card-title">WordPress Hosting</h3>
          <div className="small-text">Instant Blog and easy to manage</div>
          <div className="card-text">
            <div className="fw-bolder">Starting from</div>
            <div className="fs-32 fw-bolder">
              <CurrencyContext.Consumer>
                {(context) => {
                  return (
                    <>
                      {data.map((item, index) => (
                        <Pricing
                          key={index}
                          CurrencyPrefix={item.node.pricing}
                          pricing={item.node.pricing}
                          productID={item.node.pid}
                        />
                      ))}
                    </>
                  )
                }}
              </CurrencyContext.Consumer>
            </div>
          </div>
          <NavLink
            to="/hosting/wordpress-hosting/"
            className="stretched-link btn"
          >
            Wordpress Hosting
            <i className="bi bi-arrow-right float-end"></i>
          </NavLink>
        </div>
      </div>
    </div>
  )
}

export default WordpressHostingBlock
